import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class BrandFactoryConnectionService {
  private readonly http = inject(HttpClient);
  private readonly endPoint = environment.API_ENDPOINT + `connections/brand-factories/`;
  //create brand-factory connection
  createBrandFactoryConnection(payload: any): Observable<any> {
    return this.http.post(this.endPoint + 'bulk-create', payload);
  }
  //get brand-factory Connection
  getAllBrandFactoryConnectionWithFilters(options?: {
    brand?: string;
    factory?: string;
    country?: string;
    state?: string;
    city?: string;
    unitType?: any;
    brandOrder?: any;
    year?: any;
    status?: string;
    sortBy?: string;
    tier?: string;
    factoryTags?: any;
    startDate?: any;
    endDate?: any;
    showYears?: boolean;
    showFactoryAddress?: boolean;
    showFactoryAdmin?: boolean;
    department?: string;
    project?: string;
    allFactories?: boolean;
    sourceWise?: boolean;
    orderWise?: boolean;
  }) {
    let newFactoryTag = '';
    if (options?.factoryTags?.length) {
      options.factoryTags.forEach((element: string) => {
        newFactoryTag += `&factoryTag[]=${element}`;
      });
    }
    return this.http.get(
      `${this.endPoint}?brand=${options?.brand || ''}&factory=${
        options?.factory || ''
      }&country=${options?.country || ''}&state=${options?.state || ''}&city=${
        options?.city || ''
      }&department=${options?.department || ''}${options?.year || ''}&status=${
        options?.status || ''
      }&sortBy=${options?.sortBy || ''}&project=${
        options?.project || ''
      }${newFactoryTag}&startDate=${options?.startDate || ''}&endDate=${
        options?.endDate || ''
      }&showYears=${options?.showYears || false}&showFactoryAddress=${
        options?.showFactoryAddress || false
      }${options.unitType || ''}&allFactories=${options?.allFactories || false}&showFactoryAdmin=${
        options?.showFactoryAdmin || false
      }&sourceWise=${options.sourceWise ?? true}&orderWise=${options.orderWise ?? false}&tier=${options.tier || ''}`
    );
  }
  getBrandFactoryConnectionsV3(options: {
    brandId: string;
    searchTerm?: string;
    take?: number;
    page?: number;
    countryId?: string;
    stateId?: string;
    cityId?: string;
    departmentId?: string;
    tierId?: string;
    unitTypes?: string[];
    factoryTags?: string[];
    years?: number[];
  }) {
    let params = new HttpParams().set('brandId', options.brandId);
    const appendIfValue = (key: string, value: string | number | undefined | null) => {
      if (value === '' || value === undefined || value === null) {
        return;
      }
      params = params.set(key, String(value));
    };
    const appendArray = (key: string, values?: Array<string | number>) => {
      if (!values?.length) {
        return;
      }
      values
        .filter(value => value !== '' && value !== undefined && value !== null)
        .forEach(value => {
          params = params.append(key, String(value));
        });
    };
    appendIfValue('searchTerm', options.searchTerm);
    appendIfValue('take', options.take || 500);
    appendIfValue('page', options.page || 1);
    appendIfValue('countryId', options.countryId);
    appendIfValue('stateId', options.stateId);
    appendIfValue('cityId', options.cityId);
    appendIfValue('departmentId', options.departmentId);
    appendIfValue('tierId', options.tierId);
    appendArray('unitTypes', options.unitTypes);
    appendArray('factoryTags', options.factoryTags);
    appendArray('years', options.years);
    return this.http.get(this.endPoint, { params });
  }
  //update factory-brand connection
  updateFactoryBrandConnection(id: string, payload: any): Observable<any> {
    return this.http.patch(this.endPoint + id, payload);
  }
  //delete brand-factory connection
  deleteBrandFactoryConnection(id: string): Observable<any> {
    return this.http.delete(this.endPoint + id);
  }
  // factory-compare
  // 			options?.factory || ""
  // 			options?.city || ""
  // 			options?.year || ""
  // 			options?.sortBy || ""
  // 			options?.startDate || ""
  // 		}&endDate=${options?.endDate || ""}`
}
